module.exports = __webpack_public_path__ + "static/img/2.b4a7ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/2.png
// module id = gya7
// module chunks = 94